import { View } from 'foundations-components/components/View';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { PPUIGrid } from 'pricing-pages-ui-components/grid/PPUIGrid';
import { PPUIGridItem } from 'pricing-pages-ui-components/grid/PPUIGridItem';
import { useLocation } from 'quartz-routing/react-router';
import PublicSideNav from '../components/PublicSideNav';
import { isPublicNavItem } from '../types/PublicNavItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
/*
 * BaseLayout (HSGlobalNav header/footer) is hoisted up into PublicRootLayout
 * so it stays mounted across navigation. This component only owns the inner
 * sidenav + content shell.
 */
const PublicAppLayout = ({
  children
}) => {
  var _pathname$split$filte;
  const isMobile = useIsMobile();
  const {
    pathname
  } = useLocation();
  const rawSlug = (_pathname$split$filte = pathname.split('/').filter(Boolean)[0]) !== null && _pathname$split$filte !== void 0 ? _pathname$split$filte : '';
  const slug = rawSlug === 'revenue' ? 'commerce' : rawSlug;
  const selectedNavItem = isPublicNavItem(slug) ? slug : 'marketing';
  if (isMobile) {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(PublicSideNav, {
        selectedNavItem: selectedNavItem
      }), /*#__PURE__*/_jsx(View, {
        paddingBlockStart: "500",
        children: children
      })]
    });
  }
  return /*#__PURE__*/_jsxs(PPUIGrid, {
    inlineSize: "100%",
    maxInlineSize: "1528px",
    margin: "auto",
    paddingBlockStart: "400",
    paddingInline: "200",
    gridTemplateAreas: " \"side-nav content\" ",
    gridTemplateColumns: "minmax(280px, auto) 1fr",
    columnGap: "400",
    rowGap: "400",
    children: [/*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "side-nav",
      children: /*#__PURE__*/_jsx(PublicSideNav, {
        selectedNavItem: selectedNavItem
      })
    }), /*#__PURE__*/_jsx(PPUIGridItem, {
      gridArea: "content",
      children: children
    })]
  });
};
export default PublicAppLayout;